(function () {
  var key = 'recently_viewed';
  var wrap = document.getElementById('rvWrap');
  var panel = document.getElementById('rvPanel');

  if (!wrap || !panel) {
    return;
  }

  var fab = wrap.querySelector('.rv-fab');
  var listEl = panel.querySelector('.rv-list');
  var clearBtn = panel.querySelector('.rv-clear');

  if (!fab || !listEl || !clearBtn) {
    return;
  }

  function esc(value) {
    return (value || '').toString().replace(/[&<>"']/g, function (match) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
      }[match];
    });
  }

  function formatMoney(cents) {
    try {
      if (window.Shopify && Shopify.formatMoney) {
        return Shopify.formatMoney(cents);
      }
    } catch (error) {}

    return '$' + ((cents || 0) / 100).toFixed(2);
  }

  function render() {
    var list = [];

    try {
      list = JSON.parse(localStorage.getItem(key) || '[]');
    } catch (error) {}

    listEl.innerHTML = '';

    if (!list.length) {
      listEl.innerHTML = '<div style="padding:8px 4px;color:#666;font-size:13px;">No products yet</div>';
      return;
    }

    list.forEach(function (product, index) {
      var widthNum = product && product.width ? String(product.width).replace(/[^0-9.]/g, '').trim() : '';
      var widthTxt = widthNum ? widthNum + '" Exterior Width' : '';
      var parts = [product.vendor, product.sku, widthTxt, product.type].filter(Boolean);
      var label = parts.length ? parts.join(' ') : product.title || 'Product';
      var priceHTML = '<span class="rv-price-current">' + esc(formatMoney(product.price)) + '</span>';

      if (product.compare_at_price && Number(product.compare_at_price) > Number(product.price)) {
        priceHTML += ' <span class="rv-price-compare">' + esc(formatMoney(product.compare_at_price)) + '</span>';
      }

      var anchor = document.createElement('a');
      anchor.href = product.url || '#';
      anchor.className = 'rv-item';
      anchor.style.setProperty('--i', index);
      anchor.innerHTML =
        '<img class="rv-thumb" alt="" loading="lazy" src="' +
        (product.image || '') +
        '">' +
        '<div>' +
        '<p class="rv-title">' +
        esc(label) +
        '</p>' +
        '<div class="rv-price">' +
        priceHTML +
        '</div>' +
        '</div>';
      listEl.appendChild(anchor);
    });
  }

  function openPanel() {
    render();
    panel.classList.add('is-open');
    wrap.classList.add('open');
  }

  function closePanel() {
    panel.classList.remove('is-open');
    wrap.classList.remove('open');
  }

  function toggle() {
    if (panel.classList.contains('is-open')) {
      closePanel();
      return;
    }

    openPanel();
  }

  fab.addEventListener('click', toggle);
  clearBtn.addEventListener('click', function () {
    localStorage.removeItem(key);
    render();
  });
  document.addEventListener('click', function (event) {
    if (!panel.contains(event.target) && !wrap.contains(event.target)) {
      closePanel();
    }
  });
})();
